import React from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import FounderSection from "@/sections/FounderSection";
import FinalCTA from "@/sections/FinalCTA";
import Reveal from "@/components/Reveal";
import { HeartHandshake, Compass, ShieldCheck, Sparkles } from "lucide-react";

const values = [
 { icon: HeartHandshake, t: "Founder-first", d: "Every recommendation starts from your goals, not our margins." },
 { icon: Compass, t: "Clarity over jargon", d: "Plain-English explanations for MOA, AOA, DPIIT, ROC everything." },
 { icon: ShieldCheck, t: "Long-term trust", d: "We show up post-registration for compliance, launch and beyond." },
 { icon: Sparkles, t: "Craft in the small things", d: "Fast filings, thoughtful advice, no ghosting after payment." },
];

export default function AboutPage() {
 return (
 <div data-testid="page-about">
 <Seo
  title="About Bhavik Hariyani | HG Corporates"
  description="Meet Bhavik Hariyani, founder of HG Corporates, who guides first-time founders in Mumbai through structure, registration and compliance."
  path="/about"
  breadcrumbs={[
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
  ]}
 />
 <PageHero
 eyebrow="About"
 title="Built for founders taking the biggest step of their life."
 subtitle="HG Corporates exists because First-Time Founders across Mumbai, Navi Mumbai, Thane and the MMRDA region deserve a real partner not a paperwork factory. We are founder-led, conversation-first, and genuinely invested in your launch."
 image="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80"
 />

 <section className="bg-white">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 grid grid-cols-1 lg:grid-cols-2 gap-12">
 <Reveal>
 <h2 className="font-display text-[32px] md:text-[44px] font-black leading-[1.05] text-[#0F1115]">
 The mission
 </h2>
 <p className="mt-5 text-[16px] md:text-[17px] text-[#1C1F26] leading-relaxed">
 To make the very first steps of starting a business feel less
 lonely and less confusing. We believe founders deserve a real
 conversation before a real payment and a real relationship
 long after.
 </p>
 </Reveal>
 <Reveal delay={120}>
 <h2 className="font-display text-[32px] md:text-[44px] font-black leading-[1.05] text-[#0F1115]">
 Why we exist
 </h2>
 <p className="mt-5 text-[16px] md:text-[17px] text-[#1C1F26] leading-relaxed">
 In FY 2025–26, <strong className="font-bold text-[#0F1115]">3,43,623 new businesses</strong> were registered in India.
 <br />
 But more than <strong className="font-bold text-[#0F1115]">90% of startups fail</strong> within the first few years.
 <br />
 We help founders start right.
 </p>
 </Reveal>
 </div>
 </section>

 <FounderSection />

 <section className="bg-white border-t border-[#EAEAEA]">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-24">
 <Reveal>
 <h2 className="font-display text-[32px] md:text-[44px] font-black leading-[1.05] text-[#0F1115]">
 Our <span className="hl-yellow">values</span>.
 </h2>
 </Reveal>
 <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
 {values.map((v, i) => {
 const Icon = v.icon;
 return (
 <Reveal key={v.t} delay={i * 80}>
 <div className="bg-white border border-[#EAEAEA] rounded-2xl p-7 h-full">
 <div className="w-11 h-11 rounded-full bg-[#FFF9E6] flex items-center justify-center">
 <Icon size={18} className="text-[#0F1115]" />
 </div>
 <h3 className="mt-5 font-display font-bold text-[19px]">{v.t}</h3>
 <p className="mt-2 text-[14.5px] text-[#1C1F26] leading-relaxed">{v.d}</p>
 </div>
 </Reveal>
 );
 })}
 </div>
 </div>
 </section>

 <FinalCTA />
 </div>
 );
}
